import Section from "../../../components/Section";
import SectionLayout from "../../../components/[przyjaznedeklaracje]/_sectionLayout";
import { getSortedPostsData } from "../../../lib/posts/abc-podatkow";
import Link from "next/link";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pl";

const POSTS_PER_PAGE = 10;

dayjs.extend(localizedFormat);
dayjs.locale("pl");

export async function getServerSideProps({ params, res }) {
	res.setHeader("Cache-Control", "no-store, max-age=0");

	const allPostsData = getSortedPostsData();

	const pageParam = params?.strona;
	let page = 1;

	if (Array.isArray(pageParam)) {
		page = parseInt(pageParam[0], 10);
	} else if (pageParam) {
		page = parseInt(pageParam, 10);
	}

	const totalPages = Math.ceil(allPostsData.length / POSTS_PER_PAGE);

	if (isNaN(page) || page < 2 || page > totalPages) {
		return {
			notFound: true,
		};
	}

	const startIndex = (page - 1) * POSTS_PER_PAGE;
	const endIndex = startIndex + POSTS_PER_PAGE;

	const paginatedPosts = allPostsData.slice(startIndex, endIndex);

	return {
		props: {
			paginatedPosts,
			currentPage: page,
			totalPages,
		},
	};
}

export default function Aktualnosci({ paginatedPosts, currentPage, totalPages }) {
	const Miasto = "PRZYJAZNEDEKLARACJE";
	const Podatek = "abcpodatkow";

	const seoTitle = `ABC podatków – baza wiedzy o podatkach i opłatach lokalnych - rozliczenie deklaracji lub informacji online. Strona ${currentPage} | Przyjazne Deklaracje`;

	const seoDescription = `Chcesz dowiedzieć się więcej o deklaracjach i informacjach podatkowych? Jak rozliczyć podatek lub opłatę lokalną online? Tutaj znajdziesz słowniczek pojęć i niezbędne dane. Zobacz! Strona ${currentPage}.`;

	return (
		<SectionLayout
			miasto={Miasto}
			podatek={Podatek}
			typeHero="slider"
			breadcrumbsLayout="light"
			seoTitle={seoTitle}
			seoDescription={seoDescription}
			canonical={`https://przyjazne-deklaracje.pl/abc-podatkow/strona/${currentPage}/`}
		>
			<Section>
				<div className="pd-entries">
					<section className="pd-entries__newest">
						<h1 className="pd-entries__title">Najnowsze wpisy:</h1>

						{paginatedPosts.map(({ id, datePublication, title, description, author }, index) => (
							<article key={index} className="pd-entry">
								<header className="pd-entry__header">
									<h2 className="pd-entry__title">
										<Link
											href={`/abc-podatkow/${id}/`}
											aria-label={`Czytaj więcej o ${String(title).toLowerCase()}`}
										>
											{title}
										</Link>
									</h2>
								</header>

								<p className="pd-entry__meta">
									<span className="pd-entry__meta__date">
										<time dateTime={dayjs(datePublication).format("YYYY-MM-DD")}>
											{dayjs(datePublication).format("D MMMM YYYY")}
										</time>
									</span>
									<span className="pd-entry__meta__author">{author}</span>
								</p>

								<p className="pd-entry__description">{description}</p>

								<footer className="pd-entry__footer">
									<Link
										href={`/abc-podatkow/${id}/`}
										aria-label={`Czytaj więcej o ${String(title).toLowerCase()}`}
										className="pd-entry__readmore"
									>
										Czytaj więcej
									</Link>
								</footer>
							</article>
						))}

						<div className="pu-pagination">
							{currentPage > 1 && (
								<Link
									href={
										currentPage === 2
											? "/abc-podatkow/"
											: `/abc-podatkow/strona/${currentPage - 1}/`
									}
								>
									<span className="pagination__prev">Poprzednia strona</span>
								</Link>
							)}

							{currentPage < totalPages && (
								<Link href={`/abc-podatkow/strona/${currentPage + 1}/`}>
									<span className="pagination__next">Następna strona</span>
								</Link>
							)}
						</div>
					</section>

					<aside className="pd-entries__popular">
						<h2 className="pd-entries__title">Najpopularniejsze wpisy:</h2>

						{paginatedPosts.slice(0, 3).map(({ id, datePublication, title, author }, index) => (
							<article key={index} className="pd-entry">
								<header className="pd-entry__header">
									<h3 className="pd-entry__title">
										<Link
											href={`/abc-podatkow/${id}/`}
											aria-label={`Czytaj więcej o ${String(title).toLowerCase()}`}
										>
											{title}
										</Link>
									</h3>
								</header>

								<p className="pd-entry__meta">
									<span className="pd-entry__meta__date">
										<time dateTime={dayjs(datePublication).format("YYYY-MM-DD")}>
											{dayjs(datePublication).format("D MMMM YYYY")}
										</time>
									</span>
									<span className="pd-entry__meta__author">{author}</span>
								</p>

								<footer className="pd-entry__footer">
									<Link
										href={`/abc-podatkow/${id}/`}
										aria-label={`Czytaj więcej o ${String(title).toLowerCase()}`}
										className="pd-entry__readmore"
									>
										Czytaj więcej
									</Link>
								</footer>
							</article>
						))}
					</aside>
				</div>
			</Section>
		</SectionLayout>
	);
}